<template>
    <div id="documents">
        <!--Commandes-->
        <div id="commande" class="typeDocument">
          <div v-if="orders.length">
            <b-table class="text-center" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFilteredOrders" responsive :striped="true" :fields="fieldsCommandes" :items="orders" :current-page="currentPageCommandes" :per-page="perPage">
              <template v-slot:cell(date-creation)="data">
                <span style='font-size:14px;'>{{ data.item.date_commande }}</span>
              </template>
              <template v-slot:cell(date-livraison)="data">
                <span v-if="data.item.date_livraison" style='font-size:14px;'>{{ data.item.date_livraison }}</span>
                <span v-else style='font-size:14px;'>Non livré</span>
              </template>
              <template v-slot:cell(reference)="data">
                <span style='width:30%; font-size:14px; text-transform: uppercase;'>{{ data.item.ref_client }}</span>
              </template>
              <template v-slot:cell(prix-ht)="data">
                <span style='font-size:14px; text-transform: uppercase;'>{{ data.item.total_ht }}</span>
              </template>
              <template v-slot:cell(prix-ttc)="data">
                <span style='font-size:14px; text-transform: uppercase;'>{{ data.item.total_ttc }}</span>
              </template>
              <template v-slot:cell(document)="data">
                <span style='font-size:14px; text-transform: uppercase;'>{{ data.item.ref+'.pdf' }}</span>
              </template>
              <template v-slot:cell(download)="data">
                <a v-bind:href="'/api/downloadDoc/'+data.item.last_main_doc" download><span style="cursor:pointer;" class='fas fa-cloud-download-alt' v-b-tooltip.hover title='Télécharger'></span></a>
              </template>
              <template v-slot:cell(visual)="data">
                <a v-on:click.stop="visualDocClient(data.item)"><span style="cursor:pointer;" class='far fa-eye' v-b-tooltip.hover title='Visualiser'></span></a>
              </template>
              <!--<template v-slot:cell(comment)="data">
                <a v-on:click.stop="commentDoc(data.item.rowid)"><span style="cursor:pointer;" class='fas fa-comment-alt' v-b-tooltip.hover title='Commentaire'></span>
              </template>-->
            </b-table>
            <div v-if="orders.length>perPage">
              <b-pagination size="md" :total-rows="orders.length" v-model="currentPageCommandes" :per-page="perPage" />
            </div>
          </div>
          <div v-else>
            <h5>Aucunes commandes disponibles</h5>
          </div>
        </div>
      
        <b-modal id="modalVisualCommandes" @hide="resetModal" :title="modalVisual.title" hide-footer>
            <template>
            <iframe id="visualDoc" v-bind:src="visualSrc"></iframe>
            </template>
        </b-modal>
    </div>
  </template>
  
  <style>
  #documents{
    margin: auto;
    width: 100%;
    text-align: center;
  }
  
  #contrat > h3, #contrat .table thead th, #contrat .table td,#contrat .table th{
    border-color: #3C4694;
  }
  
  #devis > h3, #devis .table thead th, #devis .table td,#devis .table th{
    border-color: #6D3D94;
  }
  
  #commande > h3, #commande .table thead th, #commande .table td,#commande .table th{
    border-color: #ED2C74;
  }
  
  #facture > h3, #facture .table thead th, #facture .table td,#facture .table th{
    border-color: #00B7A7;
  }
  
  #documents .input-group{
    width: 60%;
  }
  
  #documents .input-group>.form-control{
    flex: 1 1 50%;
  }
  
  #visualDoc{
    width: 100%;
    height: 100%;
  }
  
  #modalVisualCommandes .modal-dialog {
    max-width: 50%;
    height: 95%;
    margin-top: 1%;
  }
  
  #modalVisualCommandes .modal-body {
    max-height: 90%;
    padding: 0;
    overflow: unset;
  }
  
  #modalVisualCommandes .modal-dialog > div{
    height: 100%;
  }
  
  </style>
  
  <script>
  import script from '../../../script/script.js';
  
  export default {
    data() {
      return {
        post: {},
        fieldsCommandes:[{key:"date-creation", label:"Date de création"},{key:"date-livraison", label:"Date de livraison"},{key:"reference", label:"Référence"},{key:"prix-ht", label:"Total(ht*)"},{key:"prix-ttc", label:"Total(ttc*)"},{key:"document", label:"Document"},{key:"download", label:""},{key:"visual", label:""}/*,{key:"comment", label:""}*/],
        currentPageCommandes: 1,
        perPage: 10,
        filter:null,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        totalRows:{
          contracts:0,
          orders:0,
          proposals:0,
          invoices:0,
        },
        modalVisual: { title: '', content: '' },
        visualSrc:''
      }
    },
    mounted:function(){
      this.$store.commit("resetDocuments")
      this.verifyRight();
      this.loadingInfo();
      this.loadDocuments("orders");
    },
    methods: {
      verifyRight: script.verifyRight,
      loadDocuments: script.loadDocuments,
      visualDocClient: script.visualDocClient,
      commentDoc: script.commentDoc,
      loadingInfo: script.loadingInfo
    },
    components: {
  
    },
    computed: {
      orders(){
        return this.$store.state.orders
      },
    }
  }
  </script>
  